<template>
  <div>
    <div class="card">
      <div class="card-body">
        <h5 class="text-uppercase">{{ $t("models.thiSinh.titleCard1") }}</h5>
        <div class="form-row">
          <div class="col-md-4 mb-3">
            <label for="txtHoTen">
              {{ $t("models.thiSinh.hoTen") }}: {{ thisinh.hoTen }}
            </label>
          </div>
          <div class="col-md-3 mb-3">
            <label for="txtNgaySinh">
              {{ $t("models.thiSinh.ngaySinh") }}: {{ thisinh.ngaySinh }}
            </label>
          </div>
          <div class="col-md-2 mb-3">
            <label for="txtSoCMND">
              {{ $t("models.thiSinh.gioiTinh") }}: {{ thisinh.gioiTinh }}
            </label>
          </div>
          <div class="col-md-3 mb-3">
            <label for="txtSoCMND">
              {{ $t("models.thiSinh.cmnd") }}: {{ thisinh.soCmnd }}
            </label>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-4 mb-3">
            <label for="txtSoDienThoai">
              {{ $t("models.thiSinh.sdt") }}: {{ thisinh.soDienThoai }}
            </label>
          </div>
          <div class="col-md-4 mb-3">
            <label for="txtEmail"
              >{{ $t("models.thiSinh.email") }}: {{ thisinh.email }}</label
            >
          </div>
          <div class="col-md-4 mb-3">
            <label for="ddlDoiTuong">
              {{ $t("models.thiSinh.doiTuong") }}: {{ thisinh.maDoiTuong }}
            </label>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-4 mb-3">
            <label for="ddlKhuVuc">
              {{ $t("models.thiSinh.khuVuc") }}: {{ thisinh.maKhuVuc | khuVuc }}
            </label>
          </div>
          <div class="col-md-8 mb-3">
            <label for="txtHoKhau">
              {{ $t("models.thiSinh.diaChi") }}: {{ thisinh.hoKhau }}
            </label>
          </div>
        </div>
      </div>

      <div class="card mt-3">
        <div class="card-body">
          <h5 class="text-uppercase">{{ $t("models.thiSinh.titleCard2") }}</h5>
          <div class="form-row">
            <div class="col-md-1 mb-3 align-self-center">
              <span> {{ $t("models.truong.lop10") }} </span>
            </div>
            <div class="col-md-9 mb-3">
              <label :for="`ddlLop10_MaTruong`">
                {{ $t("models.truong.maTruong") }} -
                {{ $t("models.truong.tenTruong") }}:
                {{ thisinh.lop10TruongId | tenTruong(truonglop10) }}
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-1 mb-3 align-self-center">
              <span>{{ $t("models.truong.lop11") }}</span>
            </div>
            <div class="col-md-9 mb-3">
              <label :for="`ddlLop11_MaTruong`">
                {{ $t("models.truong.maTruong") }} -
                {{ $t("models.truong.tenTruong") }}:
                {{ thisinh.lop11TruongId | tenTruong(truonglop11) }}
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-1 mb-3 align-self-center">
              <span>{{ $t("models.truong.lop12") }}</span>
            </div>
            <div class="col-md-9 mb-3">
              <label :for="`ddlLop12_MaTruong`">
                {{ $t("models.truong.maTruong") }} -
                {{ $t("models.truong.tenTruong") }}:
                {{ thisinh.lop12TruongId | tenTruong(truonglop12) }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="card mt-3">
        <div class="card-body">
          <h5 class="text-uppercase">{{ $t("models.thiSinh.titleCard3") }}</h5>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label for="txtDiaChiLienHe">
                {{ $t("models.thiSinh.dcLienHe") }}: {{ thisinh.diaChi }}
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="txtHoTenBo">
                {{ $t("models.thiSinh.hoTenBo") }}: {{ thisinh.hoTenBo }}
              </label>
            </div>
            <div class="col-md-4 mb-3">
              <label for="txtSDTBo">
                {{ $t("models.thiSinh.sdtBo") }}: {{ thisinh.sdtbo }}
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="txtHoTenMe">
                {{ $t("models.thiSinh.hoTenMe") }}: {{ thisinh.hoTenMe }}
              </label>
            </div>
            <div class="col-md-4 mb-3">
              <label for="txtSDTMe">
                {{ $t("models.thiSinh.sdtMe") }}: {{ thisinh.sdtme }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="card mt-3" v-if="loaiDot == 'HOCBA'">
        <div class="card-body">
          <h5 class="text-uppercase">{{ $t("models.thiSinh.titleCard4") }}</h5>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label for="txtBangHocBa">
                {{ $t("models.thiSinh.scanHocBa") }}:
                {{ file | checkFileName }}
              </label>
            </div>
          </div>
          <div
            class="form-row"
            v-for="(item, index) in nguyenvongs"
            :key="index"
          >
            <div class="col-md-2 mb-3">
              <v-text-field
                :label="$t('models.nguyenVong.stt')"
                outlined
                dense
                readonly
                :value="index + 1"
              >
              </v-text-field>
            </div>

            <div class="col-md-2 mb-3">
              <v-text-field
                :name="$t('models.nguyenVong.coSo')"
                :label="$t('models.nguyenVong.coSo')"
                outlined
                dense
                readonly
                :value="item.nganhId | tenCoSo(nganhs, cosoes)"
              >
              </v-text-field>
            </div>

            <div class="col-md-4 mb-3">
              <v-text-field
                :name="$t('models.nguyenVong.maNganh', { stt: index + 1 })"
                :label="$t('models.nguyenVong.maNganh', { stt: index + 1 })"
                outlined
                dense
                readonly
                :value="item.nganhId | maNganh(nganhs)"
              >
              </v-text-field>
            </div>

            <div class="col-md-3 mb-3" :id="`input-tohop-${index + 1}`">
              <v-text-field
                :name="$t('models.nguyenVong.toHop', { stt: index + 1 })"
                :label="$t('models.nguyenVong.toHop', { stt: index + 1 })"
                outlined
                dense
                readonly
                :value="item | toHop"
              >
              </v-text-field>
            </div>
          </div>
        </div>
      </div>

      <div class="card mt-3" v-else>
        <div class="card-body">
          <h5 class="text-uppercase">{{ $t("models.thiSinh.titleCard4") }}</h5>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label for="txtBangHocBa">
                {{ $t("models.thiSinh.scanHoSo") }}:
                {{ file | checkFileName }}
              </label>
            </div>
          </div>
          <div
            class="form-row"
            v-for="(item, index) in nguyenvongs"
            :key="index"
          >
            <div class="col-md-2 mb-3">
              <v-text-field
                :name="$t('models.nguyenVong.coSo')"
                :label="$t('models.nguyenVong.coSo')"
                outlined
                dense
                readonly
                :value="item.nganhId | tenCoSo(nganhs, cosoes)"
              >
              </v-text-field>
            </div>

            <div class="col-md-6 mb-3">
              <v-text-field
                :name="$t('models.nguyenVong.maNganh', { stt: index + 1 })"
                :label="$t('models.nguyenVong.maNganh', { stt: index + 1 })"
                outlined
                dense
                readonly
                :value="item.nganhId | maNganh(nganhs)"
              >
              </v-text-field>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3" v-if="loaiDot == 'HOCBA'">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>{{ $t("models.monHoc.title") }}</th>
              <th>{{ $t("models.diem.title10") }}</th>
              <th>{{ $t("models.diem.title11") }}</th>
              <th>{{ $t("models.diem.title12") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="diem in diems" :key="diem.tenMonHoc">
              <td>{{ diem.tenMonHoc }}</td>
              <td>
                {{ diem.diem1 }}
              </td>
              <td>
                {{ diem.diem2 }}
              </td>
              <td>
                {{ diem.diem3 }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mt-3" v-if="loaiDot == 'THPT'">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>{{ $t("models.monHoc.title") }}</th>
              <th>{{ $t("models.diem.title") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="diem in diems" :key="diem.tenMonHoc">
              <td>{{ diem.tenMonHoc }}</td>
              <td>
                {{ diem.diemM }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="form-row mt-3">
      <div class="col-3">
        <button
          id="saveThongTin"
          class="btn btn-primary form-control"
          @click="save"
        >
          {{ $t("button.luuLai") }}
        </button>
      </div>
      <div class="col-3">
        <button
          id="backEdit"
          class="btn btn-warning form-control"
          @click="comeBack('kiem_tra_lai')"
        >
          {{ $t("button.chinhSua") }}
        </button>
      </div>
    </div>
    <dialog-loader ref="dialogLoader"></dialog-loader>
  </div>
</template>

<script>
import ThongTinDangKy from "../js/thongtindangky";
export default ThongTinDangKy;
</script>

<style lang="scss" scoped></style>
